export default class Menu {
  constructor() {
    this.this = '#main-menu'
    this.$this = $(this.this)
    this.$mainMenu = $('#main-menu').find('.main-menu__ul')
    this.elementItem = '.js-hamburger, html, #main-menu, #header'
    this.$header = $('#header, #main-menu-mobile')
    this.$hamburgerMenu = $('.js-hamburger')
    this.li = this.$this.find('.main-menu__ul >li>a')
    this.liLevel1 = this.$this.find('.main-menu__ul .li-menu-item-0')
    this.isOpenMenu = 'is-open-menu'
    this.isOpenMenuChild = 'open-menu-child'
    this.isOpenChild = 'is-open-child'
    this.$linksInMenu = $('.header a:not(.skip-link), .header button')
    this.$firstLinkInMenu = this.$linksInMenu.first()
    this.$lastLinkInMenu = this.$linksInMenu.last()
    this.$skipLink = $('.header a.skip-link')
    this.ariaExpanded = 'aria-expanded'
  }

  init() {
    if (this.$this.length) {
      this.openMainMenu()
      this.clickOutSite()
      this.toggleTabIndexSkipLink()
      this.clickArrowOpenDropdownMenuLevel1()
      this.clickLiOpenDropdownMenuLevel1()
    }
  }

  openMainMenu() {
    this.$header.on('click', '.js-hamburger', (e) => {
      const ele = e.currentTarget

      if ($(ele).hasClass(this.isOpenMenu)) {
        $(this.elementItem).removeClass(this.isOpenMenu)
        this.$hamburgerMenu.find('.sr-only').text('Open menu')
        this.$hamburgerMenu.attr(this.ariaExpanded, false)
        this.$skipLink.removeAttr('tabindex')
      } else {
        $(this.elementItem).addClass(this.isOpenMenu)
        this.$hamburgerMenu.find('.sr-only').text('Close menu')
        this.$hamburgerMenu.attr(this.ariaExpanded, true)
        this.bindEventFocusOnMenu()
      }
    })
  }

    /* micro function */
  microOpenCloseLevel1(currentElement, openClass, isLiLv1 = false) {
    const ele = currentElement.currentTarget
    const eleParent = $(ele).parents('.li-menu-item-0')
    if ($(window).width() < 1199) {
      if (eleParent.find('.sub-menu').length && !eleParent.hasClass(openClass)) {
        this.liLevel1.removeClass(openClass)
        this.liLevel1.find('> .menu-item-link').each((_i, el) => {
          if ($(el).attr(this.ariaExpanded)) {
            $(el).attr(this.ariaExpanded, false)
          }
        })
        eleParent.addClass(openClass)
        $(ele).attr(this.ariaExpanded, true)
        if (isLiLv1) {
          return false
        }
      } else {
        eleParent.removeClass(openClass)
        $(ele).attr(this.ariaExpanded, false)
      }
    }
    return true
  }
    /* end micro */

  toggleTabIndexSkipLink() {
    $(window).on('resize', () => {
      if ($(window).outerWidth() < 992) {
        this.$skipLink.removeAttr('tabindex')
      }
    })
  }

  clickArrowOpenDropdownMenuLevel1() {
    this.liLevel1.on('click', '.arrows-menu', (e) => {
      e.preventDefault()
      e.stopPropagation()
      this.microOpenCloseLevel1(e, this.isOpenChild)
    })
  }

  clickLiOpenDropdownMenuLevel1() {
    this.liLevel1.on('click', 'div.sub-menu-item-0', (e) => {
      if ($(window).width() < 1200) {
        e.preventDefault()
        e.stopPropagation()
      }
      this.microOpenCloseLevel1(e, this.isOpenChild, true)
    })
  }

  bindEventFocusOnMenu() {
    this.$skipLink.attr('tabindex', -1)
    this.$firstLinkInMenu.get(0).addEventListener('keydown', this.shiftTabFocusToLast.bind(this))
    this.$lastLinkInMenu.get(0).addEventListener('keydown', this.tabFocusToFirst.bind(this))
  }

  tabFocusToFirst(e) {
    if (e.which === 9 && $(window).outerWidth() < 992 && !e.shiftKey) {
      e.preventDefault()
      this.$firstLinkInMenu.focus()
    }
  }

  shiftTabFocusToLast(e) {
    if (e.which === 9 && $(window).outerWidth() < 992 && e.shiftKey) {
      e.preventDefault()
      this.$lastLinkInMenu.focus()
    }
  }

  clickOutSite() {
    $(document).on('click', (event) => {
      if (!$(event.target).closest('#header.is-open-menu').length) {
        $(this.elementItem).removeClass(this.isOpenMenu)
      }
    })
  }

  closeAllSubmenu() {
    const $liHover = this.$this.find('.main-menu__ul>li.hovering')
    $liHover.removeClass('hovering')
    if ($liHover.hasClass('has-sub')) {
      $liHover.find('> a').attr(this.ariaExpanded, false)
    }
  }

}

new Menu().init()
